import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, Directive, ViewChild, Injectable, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from 'primeng/button';
import { ButtonModule } from 'primeng/button';
import * as i1$1 from '@angular/forms';
import { FormsModule, ReactiveFormsModule, FormBuilder } from '@angular/forms';

class CommandComponent {
    constructor() {
        this.onExecute = new EventEmitter();
        this.commandClasses = 'col-12';
    }
    ngOnInit() {
        if (this.configuration.classes != null)
            this.commandClasses = this.configuration.classes;
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('configuration')) {
            if (this.configuration.classes != null)
                this.commandClasses = this.configuration.classes;
        }
    }
}
CommandComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: CommandComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
CommandComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: CommandComponent, selector: "iot-command", inputs: { command: "command", params: "params", configuration: "configuration" }, outputs: { onExecute: "onExecute" }, usesOnChanges: true, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: CommandComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-command',
                    template: '',
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { command: [{
                type: Input
            }], params: [{
                type: Input
            }], configuration: [{
                type: Input
            }], onExecute: [{
                type: Output
            }] } });

class CommandContainerRefDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
}
CommandContainerRefDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: CommandContainerRefDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive });
CommandContainerRefDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: CommandContainerRefDirective, selector: "[commandContainerRef]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: CommandContainerRefDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[commandContainerRef]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; } });

class CommandFormWrapperComponent {
    constructor(componentFactoryResolver) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.onExecute = new EventEmitter();
    }
    ngOnInit() {
        const viewContainerRef = this.commandContainerReference.viewContainerRef;
        viewContainerRef.clear();
        if (this.command.componentType) {
            const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.command.componentType);
            this.componentRef = viewContainerRef.createComponent(componentFactory);
            this.componentRef.instance.command = this.command.commandName;
            this.componentRef.instance.params = this.command.params;
            this.componentRef.instance.configuration = this.command.configuration;
            this.onExecuteSubscription = this.componentRef.instance.onExecute.subscribe(commandExec => this.onExecute.emit(commandExec));
        }
    }
    ngOnDestroy() {
        if (this.onExecuteSubscription != null)
            this.onExecuteSubscription.unsubscribe();
    }
}
CommandFormWrapperComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: CommandFormWrapperComponent, deps: [{ token: i0.ComponentFactoryResolver }], target: i0.ɵɵFactoryTarget.Component });
CommandFormWrapperComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: CommandFormWrapperComponent, selector: "iot-command-form-wrapper", inputs: { command: "command" }, outputs: { onExecute: "onExecute" }, viewQueries: [{ propertyName: "commandContainerReference", first: true, predicate: CommandContainerRefDirective, descendants: true, static: true }], ngImport: i0, template: "<ng-template commandContainerRef></ng-template>\r\n", styles: [""], directives: [{ type: CommandContainerRefDirective, selector: "[commandContainerRef]" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: CommandFormWrapperComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-command-form-wrapper',
                    templateUrl: './command-form-wrapper.component.html',
                    styleUrls: ['./command-form-wrapper.component.css']
                }]
        }], ctorParameters: function () { return [{ type: i0.ComponentFactoryResolver }]; }, propDecorators: { command: [{
                type: Input
            }], onExecute: [{
                type: Output
            }], commandContainerReference: [{
                type: ViewChild,
                args: [CommandContainerRefDirective, { static: true }]
            }] } });

class CommandFormComponent {
    constructor() {
        this.commandClasses = 'col-12';
        this.formattedCommands = [];
        this.onExecute = new EventEmitter();
    }
    ngOnInit() {
        this.formattedCommands = this.commandsFormatter();
        if (this.configuration.classes != null)
            this.commandClasses = this.configuration.classes;
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('configuration')) {
            if (this.configuration.classes != null)
                this.commandClasses = this.configuration.classes;
        }
    }
    commandsFormatter() {
        let commands = [];
        Object.entries(this.commands.commands).forEach(entry => {
            const [commandName, params] = entry;
            const componentType = this.commandRegistry.get(commandName);
            if (componentType) {
                const command = {
                    commandName,
                    params,
                    componentType,
                    configuration: this.configuration.commands[commandName]
                };
                commands.push(command);
            }
        });
        return commands;
    }
}
CommandFormComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: CommandFormComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
CommandFormComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: CommandFormComponent, selector: "iot-command-form", inputs: { commands: "commands", commandRegistry: "commandRegistry", configuration: "configuration" }, outputs: { onExecute: "onExecute" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"grid\">\r\n    <div class=\"p-3\" [ngClass]=\"this.commandClasses\" *ngFor=\"let command of formattedCommands\">\r\n        <iot-command-form-wrapper [command]=\"command\" (onExecute)=\"this.onExecute.emit($event)\">\r\n        </iot-command-form-wrapper>\r\n    </div>\r\n</div>", styles: [""], components: [{ type: CommandFormWrapperComponent, selector: "iot-command-form-wrapper", inputs: ["command"], outputs: ["onExecute"] }], directives: [{ type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: CommandFormComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-command-form',
                    templateUrl: './command-form.component.html',
                    styleUrls: ['./command-form.component.css']
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { commands: [{
                type: Input
            }], commandRegistry: [{
                type: Input
            }], configuration: [{
                type: Input
            }], onExecute: [{
                type: Output
            }] } });

class CommandWrapperComponent {
    constructor() {
        this.onExecute = new EventEmitter();
    }
    ngOnInit() { }
    get buttonPosition() {
        return this.configuration.buttonPosition != null ? this.configuration.buttonPosition : 'NEW_LINE';
    }
    onExecuteButtonClick() {
        this.onExecute.emit();
    }
}
CommandWrapperComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: CommandWrapperComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
CommandWrapperComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: CommandWrapperComponent, selector: "iot-command-wrapper", inputs: { header: "header", configuration: "configuration" }, outputs: { onExecute: "onExecute" }, ngImport: i0, template: "<div class=\"flex justify-content-between\">\r\n    <div *ngIf=\"this.header != null\" class=\"header text-2xl font-bold mb-3\">\r\n        {{header}}\r\n    </div>\r\n    <ng-container *ngIf=\"buttonPosition === 'HEADER'\" [ngTemplateOutlet]=\"button\"></ng-container>\r\n</div>\r\n<ng-container *ngIf=\"buttonPosition === 'INLINE'\" [ngTemplateOutlet]=\"buttonInline\"></ng-container>\r\n<ng-container *ngIf=\"buttonPosition === 'NEW_LINE'\" [ngTemplateOutlet]=\"buttonJumpLine\"></ng-container>\r\n\r\n<ng-template #button>\r\n    <p-button type=\"button\" [disabled]=\"!this.configuration.valid\"\r\n        label=\"{{this.configuration.literal ? this.configuration.literal : 'Execute'}}\"\r\n        styleClass=\"{{this.configuration.classes != null ? this.configuration.classes : ''}}\"\r\n        (click)=\"onExecuteButtonClick()\"></p-button>\r\n</ng-template>\r\n\r\n<ng-template #buttonInline>\r\n    <div class=\"flex\">\r\n        <div class=\"w-full mr-3\">\r\n            <ng-container *ngTemplateOutlet=\"commandContent\"></ng-container>\r\n        </div>\r\n        <div class=\"submit text-right ml-auto mr-2 mt-auto mb-2\">\r\n            <ng-container *ngTemplateOutlet=\"button\"></ng-container>\r\n        </div>\r\n    </div>\r\n</ng-template>\r\n\r\n<ng-template #buttonJumpLine>\r\n    <ng-container *ngTemplateOutlet=\"commandContent\"></ng-container>\r\n    <div class=\"submit text-right ml-auto mr-2 mt-auto mb-auto\">\r\n        <ng-container *ngTemplateOutlet=\"button\"></ng-container>\r\n    </div>\r\n</ng-template>\r\n\r\n<ng-template #commandContent>\r\n    <div class=\"command w-full\">\r\n        <ng-content></ng-content>\r\n    </div>\r\n</ng-template>\r\n", styles: [""], components: [{ type: i1.Button, selector: "p-button", inputs: ["type", "iconPos", "icon", "badge", "label", "disabled", "loading", "loadingIcon", "style", "styleClass", "badgeClass"], outputs: ["onClick", "onFocus", "onBlur"] }], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: CommandWrapperComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-command-wrapper',
                    templateUrl: './command-wrapper.component.html',
                    styleUrls: ['./command-wrapper.component.css'],
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { header: [{
                type: Input
            }], configuration: [{
                type: Input
            }], onExecute: [{
                type: Output
            }] } });

var ValidatorsEnum;
(function (ValidatorsEnum) {
    ValidatorsEnum[ValidatorsEnum["validValues"] = 0] = "validValues";
    ValidatorsEnum[ValidatorsEnum["validRange"] = 1] = "validRange";
    ValidatorsEnum[ValidatorsEnum["minValue"] = 2] = "minValue";
    ValidatorsEnum[ValidatorsEnum["maxValue"] = 3] = "maxValue";
    ValidatorsEnum[ValidatorsEnum["required"] = 4] = "required";
    ValidatorsEnum[ValidatorsEnum["minLength"] = 5] = "minLength";
    ValidatorsEnum[ValidatorsEnum["maxLength"] = 6] = "maxLength";
    ValidatorsEnum[ValidatorsEnum["minNumberValuesSelected"] = 7] = "minNumberValuesSelected";
    ValidatorsEnum[ValidatorsEnum["maxNumberValuesSelected"] = 8] = "maxNumberValuesSelected";
    ValidatorsEnum[ValidatorsEnum["pattern"] = 9] = "pattern";
})(ValidatorsEnum || (ValidatorsEnum = {}));

class ValidatorService {
    constructor() { }
    getValidators(params) {
        let _validators = [];
        params.validators.forEach(validator => {
            const [validatorName, configuration] = Object.entries(validator)[0];
            if (ValidatorsEnum[ValidatorsEnum.validValues] === validatorName)
                _validators.push(this.validValuesValidator(configuration));
            else if (ValidatorsEnum[ValidatorsEnum.validRange] === validatorName)
                _validators.push(this.validRangeValidator(configuration));
        });
        return _validators;
    }
    validValuesValidator(configuration) {
        return (control) => {
            const valid = configuration.includes(control.value);
            return !valid ? { invalidValue: { value: control.value } } : null;
        };
    }
    validRangeValidator(configuration) {
        return (control) => {
            const valid = control.value != null && control.value >= configuration[0] && control.value <= configuration[1];
            return !valid ? { invalidRangeValue: { value: control.value } } : null;
        };
    }
}
ValidatorService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ValidatorService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ValidatorService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ValidatorService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ValidatorService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class BuildFormService {
    constructor(fb, validatorService) {
        this.fb = fb;
        this.validatorService = validatorService;
    }
    buildForm(params) {
        let formGroup = this.fb.group({});
        params.forEach(param => {
            formGroup.addControl(param[0], this.fb.control(param[1].value, this.validatorService.getValidators(param[1])));
        });
        return formGroup;
    }
}
BuildFormService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: BuildFormService, deps: [{ token: i1$1.FormBuilder }, { token: ValidatorService }], target: i0.ɵɵFactoryTarget.Injectable });
BuildFormService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: BuildFormService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: BuildFormService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.FormBuilder }, { type: ValidatorService }]; } });

class SharedModule {
}
SharedModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SharedModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SharedModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SharedModule, declarations: [CommandComponent,
        CommandWrapperComponent,
        CommandFormComponent,
        CommandFormWrapperComponent,
        CommandContainerRefDirective], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ButtonModule], exports: [CommandComponent,
        CommandWrapperComponent,
        CommandFormComponent,
        CommandFormWrapperComponent,
        CommandContainerRefDirective] });
SharedModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SharedModule, providers: [
        FormBuilder
    ], imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            ButtonModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SharedModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CommandComponent,
                        CommandWrapperComponent,
                        CommandFormComponent,
                        CommandFormWrapperComponent,
                        CommandContainerRefDirective
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        ButtonModule
                    ],
                    exports: [
                        CommandComponent,
                        CommandWrapperComponent,
                        CommandFormComponent,
                        CommandFormWrapperComponent,
                        CommandContainerRefDirective
                    ],
                    providers: [
                        FormBuilder
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { BuildFormService, CommandComponent, CommandContainerRefDirective, CommandFormComponent, CommandFormWrapperComponent, CommandWrapperComponent, SharedModule, ValidatorService, ValidatorsEnum };
